import dayjs from 'dayjs'

// 日時の表示用フォーマット。view 層（components/view）から参照されるため common/util に置く。
// common/form/date.ts はここを再エクスポートしている。
export const dateStr = (date: Date | string): string => {
  return dayjs(date).format('YYYY/MM/DD')
}

export const dateTimeStr = (date: Date | string, options?: { omitSecond: boolean }): string => {
  return dayjs(date).format(options?.omitSecond ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD HH:mm:ss')
}

export const timeStr = (date: Date | string): string => {
  return dayjs(date).format('HH:mm:ss')
}
